/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）、advertisingservice.html。
 * Section 8：cj-guarantee-section 3 保障（金色印章 + 3 卡片，≤980 转单列）。
 * 注意事项：文案（seal/title/desc/cards）经 ConstantsContext 取词，配色与 SVG 图标为视觉资产保留在组件内。
 */
import React, { useContext } from 'react';
import ConstantsContext from './ConstantsContext';
import { mix } from '../colorMix';

// 视觉资产（配色 + 图标）顺序与 GUARANTEE.cards 一一对应
var CARD_VISUALS = [
  { accent: '#77c9e8', soft: 'rgba(79,177,210,.10)', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"><path d="M20 7v5h-5" /><path d="M4 17v-5h5" /><path d="M6.1 9A7 7 0 0 1 18 6l2 1" /><path d="M17.9 15A7 7 0 0 1 6 18l-2-1" /></svg>) },
  { accent: '#c28cff', soft: 'rgba(169,108,226,.10)', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"><path d="M12 3 5 6v5c0 4.4 2.8 8.4 7 10 4.2-1.6 7-5.6 7-10V6l-7-3Z" /><path d="m9 12 2 2 4-4" /></svg>) },
  { accent: '#cfd6df', soft: 'rgba(194,204,214,.08)', icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"><path d="M4 13a8 8 0 0 1 16 0" /><path d="M4 13v4a2 2 0 0 0 2 2h2v-6H4Z" /><path d="M20 13v4a2 2 0 0 1-2 2h-2v-6h4Z" /><path d="M12 19v2" /></svg>) },
];

// 由 accent 主色预算派生 CSS 变量（等价原 less 的 color-mix）
function accentVars(accent, soft) {
  if (!accent) return { '--soft': soft };
  return {
    '--accent': accent,
    '--soft': soft,
    '--accent-hover-bd': mix(accent, 'rgba(255,255,255,.08)', 30), // hover 描边
    '--accent-icon-bd': mix(accent, 'transparent', 28),            // 图标描边
    '--accent-icon-bg': mix(accent, 'transparent', 11),            // 图标底色
  };
}

function Guarantee() {
  const { GUARANTEE } = useContext(ConstantsContext);
  return (
    <section className="cj-guarantee-section">
      <div className="cj-guarantee-section__wrap">
        <div className="cj-guarantee-section__layout">
          <div className="cj-guarantee-section__intro">
            <div className="cj-guarantee-section__seal-label">{GUARANTEE.sealLabel}</div>
            <div className="cj-guarantee-seal" aria-label="100% Guarantee">
              <div className="cj-guarantee-seal__laurel" />
              <div className="cj-guarantee-seal__content">
                <svg className="cj-guarantee-seal__crown" viewBox="0 0 48 32" fill="none">
                  <path d="M5 25 2 8l12 8L24 3l10 13 12-8-3 17H5Z" fill="currentColor" />
                  <path d="M7 28h34" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                </svg>
                <div className="cj-guarantee-seal__small">{GUARANTEE.sealPremium}</div>
                <div className="cj-guarantee-seal__percent">{GUARANTEE.sealPercent}</div>
                <div className="cj-guarantee-seal__word">{GUARANTEE.sealWord}</div>
              </div>
            </div>
            <h2 className="cj-guarantee-section__title">{GUARANTEE.title}</h2>
            <p className="cj-guarantee-section__description">{GUARANTEE.description}</p>
          </div>

          <div className="cj-guarantee-list">
            {GUARANTEE.cards.map((c, i) => {
              var v = CARD_VISUALS[i] || {};
              return (
                <article className="cj-guarantee-card" key={c.h3} style={accentVars(v.accent, v.soft)}>
                  <div className="cj-guarantee-card__icon">{v.icon}</div>
                  <div>
                    <h3>{c.h3}</h3>
                    <p>{c.p}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Guarantee;
